export default function ServiceAreas() {
  const locations = [
    { name: 'Joplin, MO', icon: 'ri-map-pin-fill' },
    { name: 'Carthage, MO', icon: 'ri-map-pin-fill' },
    { name: 'Webb City, MO', icon: 'ri-map-pin-fill' },
    { name: 'Carl Junction, MO', icon: 'ri-map-pin-fill' },
    { name: 'Sarcoxie, MO', icon: 'ri-map-pin-fill' },
    { name: 'Oronogo, MO', icon: 'ri-map-pin-fill' },
    { name: 'Jasper, MO', icon: 'ri-map-pin-fill' },
    { name: 'Galena, KS', icon: 'ri-map-pin-fill' },
    { name: 'Baxter Springs, KS', icon: 'ri-map-pin-fill' }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            <strong>Service Areas</strong>
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Proudly serving communities across Missouri and Kansas with professional painting and landscape services
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {locations.map((location, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl p-6 hover:bg-teal-50 transition-all duration-300 hover:shadow-md cursor-pointer group"
            >
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center group-hover:bg-teal-600 transition-colors">
                  <i className={`${location.icon} text-teal-600 text-xl group-hover:text-white transition-colors`}></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900">{location.name}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 text-base">
            Don't see your area listed? <strong>Contact us</strong> to see if we can serve your location!
          </p>
        </div>
      </div>
    </section>
  );
}
